import { FieldFunctionOptions, InMemoryCache, Reference } from '@apollo/client';

import { fragments } from './fragments';
import { introspection } from './generated';
import { queries } from './queries';

let cache: InMemoryCache;

/**
 * Read all cache references matching a __typename and optional filter.
 * Replaces @nerdwallet/apollo-cache-policies' readReferenceWhere.
 */
export const readReferenceWhere = (
  cacheInstance: InMemoryCache,
  options: {
    __typename: string;
    readField: FieldFunctionOptions['readField'];
    filter: (
      ref: Reference,
      readField: FieldFunctionOptions['readField']
    ) => boolean;
  }
): Reference[] | undefined => {
  const data = cacheInstance.extract();
  const refs: Reference[] = [];

  for (const key of Object.keys(data)) {
    const entry = data[key];
    if (
      entry &&
      typeof entry === 'object' &&
      '__typename' in entry &&
      entry.__typename === options.__typename
    ) {
      const ref: Reference = { __ref: key };
      if (options.filter(ref, options.readField)) {
        refs.push(ref);
      }
    }
  }

  return refs.length > 0 ? refs : undefined;
};

export const getCache = (forceRecreate = false) => {
  if (!cache || forceRecreate) {
    cache = new InMemoryCache({
      typePolicies: {
        Query: {
          fields: { ...queries },
        },
        ...fragments,
      },
      possibleTypes: introspection.possibleTypes,
    });
  }

  return cache;
};
